module.exports = __webpack_public_path__ + "static/media/11_Luftgitarr - Trubaduren (ft Arif)_lowered for context_eq 05-14.55f4098f.mp3";